module.exports = __webpack_public_path__ + "static/RST-Anschlussschlauch-19270703669cccacd9ec921f4b7c51c8.jpg";